import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-slide-toggle-container',
  templateUrl: './slide-toggle-container.component.html',
  styleUrls: ['./slide-toggle-container.component.scss'],
})
export class SlideToggleContainerComponent {
  @Input() isOn: boolean;

  @Input() title: string;
  @Input() description: string;
  @Input() textOn = 'On';
  @Input() textOff = 'Off';

  @Input() flexLeft = '50%';
  @Input() flexRight = '50%';
}
